// src/features/notfound/NotFound.jsx
import React from 'react';
import Header from "../../components/header1/Header1";
import Footer from '../../components/footer/Footer';

const NotFound = () => (<>
    <Header />
  <div className="flex flex-col items-center justify-center h-[70vh]">
    <h1 className="text-4xl font-bold mb-4">404 - Page Not Found</h1>
    <p className="text-lg text-gray-600">Sorry, the page you are looking for does not exist.</p>
  </div>
    <Footer/>
  </>
);

export default NotFound;
